import React, { Fragment } from "react";
import { Container } from "react-bootstrap";
import { useSelector } from "react-redux";
import { ApplicationRoutes } from "../../routes/ApplicationRoutes";
import ErrorBoundary from "../common/ErrorBoundary";
import UiMainWrapper from "../_uiComponents/common/UiMainWrapper";
import { UiNavBar } from "../_uiComponents/UiNavbar";
import { UiWhiteCard } from "../_uiComponents/common/UiWhiteCard";
import { BillPaymentUnSuccessIcon } from "../../styles/img/svg/BillPaymentUnSuccessIcon";

const Application = (props) => {
  const multiTabOpen = useSelector((state) => state.auth?.multiTabOpen);

  return (
    <Fragment>
      <ErrorBoundary>
        <div className="dl-main-wrapper">
          <UiMainWrapper>
            <>
              {!multiTabOpen ? (
                <>
                  <UiNavBar />
                  <ErrorBoundary>
                    <ApplicationRoutes {...props} />
                  </ErrorBoundary>
                </>
              ) : (
                <>
                  <div className="df-user-profile df-transaction-confirmation">
                    <Container maxWidth="md" className="df-pos-rel">
                      <UiWhiteCard>
                        <div className="df-confirmation-card">
                          <div className="df-confirmation-card__header">
                            <BillPaymentUnSuccessIcon />
                            <h4 className={"df-danger"}>Error!</h4>
                            <p>
                              This application supports the use of single tab
                              within your browser. Please close any open tabs
                              before trying again.
                            </p>
                          </div>
                        </div>
                      </UiWhiteCard>
                    </Container>
                  </div>
                </>
              )}
            </>
          </UiMainWrapper>
        </div>
      </ErrorBoundary>
    </Fragment>
  );
};

export default Application;
